/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_SettingsInputs */

const en_portalframe_settings = /** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const ar_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const he_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const ur_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const es_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const fr_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const de_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const pt_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const hi_portalframe_settings = en_portalframe_settings;

/** @type {(inputs: Portalframe_SettingsInputs) => LocalizedString} */
const bn_portalframe_settings = en_portalframe_settings;

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Portalframe_SettingsInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_settings = /** @type {((inputs?: Portalframe_SettingsInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_SettingsInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_settings(inputs)
	if (locale === "he") return he_portalframe_settings(inputs)
	if (locale === "ur") return ur_portalframe_settings(inputs)
	if (locale === "es") return es_portalframe_settings(inputs)
	if (locale === "fr") return fr_portalframe_settings(inputs)
	if (locale === "de") return de_portalframe_settings(inputs)
	if (locale === "pt") return pt_portalframe_settings(inputs)
	if (locale === "hi") return hi_portalframe_settings(inputs)
	if (locale === "bn") return bn_portalframe_settings(inputs)
	return /** @type {LocalizedString} */ ("Settings")
});